import React, { Component } from "react";
import { API } from "aws-amplify";
import { FormGroup, FormControl, FormCheck, Button, Form, Checkbox } from 'react-bootstrap';
import "./assets/feature.scss";
import feedback from "./assets/feedback-2.jpg";
import LoaderButton from "../../../components/LoaderButton";

export default class Feedback extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      feedbackSubmitted: false,
      email: "",
      type: "",
      feedback: "",
      improvements: ""
    };
  }

  toggleCheckboxValue = event => {
    this.setState({ type: event.target.value });
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  sendEmail(params) {
    return API.post("stories", "/feedback", {
      body: params
    });
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    const email = {
      email: this.state.email,
      type: this.state.type,
      feedback: this.state.feedback,
      improvements: this.state.improvements
    };

    try {
      await this.sendEmail(email);
      this.setState({ feedbackSubmitted: true });
      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false });
    }
  }

  render() {
    return (
      <div>
        <p>Help us to help you! We would love to hear how we can
        improve your experience!</p>
        <div className="col-lg-6 col-sm-12">
          <div className="row">
            <img src={feedback} alt="feedback" />
          </div>
        </div>

        <div className="col-lg-6 col-sm-12">
          {this.state.feedbackSubmitted &&
            <div className="row thanks">
              <h3>Thank you for your feedback!</h3>
            </div>
          }
          {!this.state.feedbackSubmitted &&
            <div className="row">
              <Form className="feedback-form" onSubmit={this.handleSubmit}>
                <FormGroup controlId="email" bsSize="large">
                  <Form.Label>Email</Form.Label>
                  <FormControl
                    type="email"
                    placeholder="your email..."
                    onChange={this.handleChange}
                    value={this.state.email}
                  />
                </FormGroup>
                <FormGroup>
                  <Form.Label as="legend" sm={2}>
                    Feedback Type
                  </Form.Label>
                  <div>
                    <Form.Check
                      type="radio"
                      name="feedback-radio"
                      value="comments"
                      label="comments"
                      onChange={this.toggleCheckboxValue}
                    />
                    <Form.Check
                      type="radio"
                      name="feedback-radio"
                      value="questions"
                      label="questions"
                      onChange={this.toggleCheckboxValue}
                    />
                    <Form.Check
                      type="radio"
                      name="feedback-radio"
                      value="bug"
                      label="bug report"
                      onChange={this.toggleCheckboxValue}
                    />
                    <Form.Check
                      type="radio"
                      name="feedback-radio"
                      value="feature"
                      label="feature request"
                      onChange={this.toggleCheckboxValue}
                    />
                  </div>
                </FormGroup>
                <FormGroup controlId="feedback" bsSize="large">
                  <Form.Label>Feedback*</Form.Label>
                  <FormControl
                    placeholder="Your Feedback..."
                    as="textarea"
                    rows="4"
                    onChange={this.handleChange}
                    value={this.state.feedback}
                    required
                  />
                </FormGroup>
                <FormGroup controlId="improvements" bsSize="large">
                  <Form.Label>Suggestions For Improvement</Form.Label>
                  <FormControl
                    placeholder="Your Improvements..."
                    type="text"
                    onChange={this.handleChange}
                    value={this.state.improvements}
                  />
                </FormGroup>
                <LoaderButton
                  block
                  bsSize="large"
                  className="secondary-cta"
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="submit"
                  loadingText="submitting..."
                />
              </Form>
            </div>
          }

        </div>
      </div>
    );

  }



}



// WEBPACK FOOTER //
// ./src/containers/main/features/Feedback.js